import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    flex: 0.7,
    alignItems: "center",
    justifyContent: "center",
  },
  logout: {
    position: "absolute",
    top: "3vh",
    right: "6vw",
  },
  logoutText: {
    fontSize: "$h4",
    color: "gray",
  },
  title: {
    padding: 15,
  },
});
